/**
 * Smoothly scrolls the error element into view.
 *
 * Historically this hardcoded `document.querySelector('.error-message')`, but
 * callers render their error elements with CSS-module (hashed) class names
 * (e.g. `authStyles['error-message']`), so the literal `.error-message`
 * selector never matched and scrolling was a silent no-op. Callers must now
 * pass their actual target.
 *
 * @param target - a DOM Element to scroll directly, or a selector string
 *   (e.g. `.${authStyles['error-message']}`) to query for.
 */
export const scrollToError = (target: Element | string): void => {
  setTimeout(() => {
    const errorElement: Element | null =
      target instanceof Element ? target : document.querySelector(target);
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 100);
};
